module.exports = __webpack_public_path__ + "fonts/visuelt-pro-regular.cc055616.woff";